import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import api from '@/lib/api';

const GRADIENTS = [
  'linear-gradient(135deg, #D44F2E, #F07B1D)',
  'linear-gradient(135deg, #2F9FC8, #18B574)',
  'linear-gradient(135deg, #7C4FD4, #A855F7)',
  'linear-gradient(135deg, #C9950C, #F07B1D)',
  'linear-gradient(135deg, #18B574, #2F9FC8)',
  'linear-gradient(135deg, #F07B1D, #D44F2E)',
  'linear-gradient(135deg, #A855F7, #2F9FC8)',
];

export const RisingVoicesStrip = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchRising = async () => {
      try {
        const res = await api.get('/users/trending', { params: { limit: 7 }, withCredentials: true });
        setUsers(res.data || []);
      } catch {
        // Silently fail — strip just won't render
      }
    };
    fetchRising();
  }, []);

  if (users.length === 0) return null;

  return (
    <div className="rv-strip">
      <div className="rv-lbl">&#128293; Rising Voices This Week</div>
      <div className="rv-row">
        {users.map((user, i) => (
          <Link to={`/profile/${user.username}`} className="rv-chip" key={user.user_id}>
            {user.picture ? (
              <Avatar className="h-[26px] w-[26px]">
                <AvatarImage src={user.picture} alt={user.name} />
                <AvatarFallback className="rv-av" style={{ background: GRADIENTS[i % GRADIENTS.length] }}>
                  {(user.name || user.username || 'U').charAt(0).toUpperCase()}
                </AvatarFallback>
              </Avatar>
            ) : (
              <div className="rv-av" style={{ background: GRADIENTS[i % GRADIENTS.length] }}>
                {(user.name || user.username || 'U').charAt(0).toUpperCase()}
              </div>
            )}
            <span className="rv-name">@{user.username}</span>
            {user.trending_score > 0 && (
              <span className="rv-heat">&#128293;+{user.trending_score}</span>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
};
